/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
'use strict';
angular.module('createSMSModule', []).controller('createSMSCtrl', [
    '$scope',
    '$element',
    '$validation',
    'modalDialog',
    '$modalInstance',
    'httpService',
    'id',
    'isCreate',
    '$q',
    'checkPhoneAndEmail',
    function(
        $scope,
        $element,
        $validation,
        modalDialog,
        $modalInstance,
        httpService,
        id,
        isCreate,
        $q,
        checkPhoneAndEmail
    ) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                isCreate: isCreate,
                // 平台名称
                company: {},
                // 通过状态显示
                testPass: false,
                // 是否通过
                pass: false,
                typeOptions: [
                    // {
                    //     name: 'Duanxinbao',
                    //     value: 0
                    // },
                    // {
                    //     name: 'Aliyun',
                    //     value: 1
                    // },
                    // {
                    //     name: 'Cloopen',
                    //     value: 2
                    // }
                    {
                        name: 'LuoSiMao',
                        value: 0
                    }
                ]
            };
            $scope.smsInfo = {
                id: id,
                isDefault: 0
            };
            $scope.data = {
                phone: ''
            };
        }
        function initData() {
            if (!$scope.status.isCreate) {
                requestData();
            }
        }
        /**
         * 查询表单数据
         */
        function requestData() {
            var params = {
                mobileSmsId: id
            };
            $scope.loadingPromise = httpService
                .http('/mcnadmin/admin/mobileSms/find.do', params, 'post')
                .then(function(data) {
                    var data = data.data;
                    $scope.smsInfo = {
                        'id': $scope.smsInfo.id,
                        'baseUrl': data.baseUrl,
                        'sign': data.sign,
                        'temp': data.temp,
                        'ackName': data.ackName,
                        'ackSecret': data.ackSecret,
                        'isDefault': data.isDefault
                    };
                    $scope.status.company = _.filter(
                        $scope.status.typeOptions,
                        ['name', data.company]
                    )[0];
                    $scope.smsInfo.company = $scope.status.company.name;
                });
        }
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $validation
                .validate($scope.createForm)
                .success(function() {
                    $scope.smsInfo.company = $scope.status.company.name;
                    $modalInstance.close($scope.smsInfo);
                })
                .error(function() {
                    angular.invalidPosition($scope.createForm, $element);
                });
        };
        /**
         * 测试是否通过
         */
        $scope.testPass = function() {
            var params = {
                phone: $scope.data.phone
            };
            params = Object.assign({}, params, $scope.smsInfo);
            $scope.loadingPromise = httpService
                .http('/mcnadmin/admin/mobileSms/testSend.do', params, 'post')
                .then(function(data) {
                });
        };
        /**
         * 选择公司
         */
        $scope.selectCompany = function() {
            $scope.smsInfo.company = $scope.status.company.name;
        };
    }
]);
